var map = {
	"./2B.png": "60fc",
	"./2R.png": "0ed3",
	"./3B.png": "efd1",
	"./3R.png": "f2c9",
	"./4B.png": "d922",
	"./4R.png": "df6e",
	"./5B.png": "9d3b",
	"./5R.png": "bd8e",
	"./6B.png": "6b6a",
	"./6R.png": "461f",
	"./7B.png": "0172",
	"./7R.png": "6850",
	"./8B.png": "54f6",
	"./8R.png": "6988",
	"./9B.png": "24c7",
	"./9R.png": "d911",
	"./AB.png": "dbe1",
	"./AR.png": "378b",
	"./Back.png": "d8d3",
	"./HiButton.png": "1c2d",
	"./JB.png": "7aa0",
	"./JR.png": "af2b",
	"./JokerJ.png": "6187",
	"./KB.png": "8e25",
	"./KR.png": "3ea9",
	"./LoButton.png": "3f3d",
	"./QB.png": "b21e",
	"./QR.png": "fd65",
	"./cardDeck.png": "c764",
	"./down.png": "299e",
	"./hilo-down.png": "43c7",
	"./hilo-up.png": "07e8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0fef";